<app-header></app-header>
<main>
    <section class="hero">
        <div class="hero-content">
            <div class="event-date">26 lutego 2026 (czwartek)</div>
            <h1>Przeglądy Techniczne i cKOB<br />w Erze Cyfryzacji</h1>
            <p class="subtitle">
                Weź udział w szkoleniu o przeglądach technicznych i cKOB w
                świetle zmieniających się przepisów Prawa Budowlanego.
            </p>
            <div class="hero-nav">
                <a
                    class="hero-nav-tile"
                    [routerLink]="['/szkolenie']"
                    fragment="speakers"
                >
                    <span class="hero-nav-icon">🎓</span>
                    <span class="hero-nav-label">Wykładowcy</span>
                </a>
                <a
                    class="hero-nav-tile"
                    [routerLink]="['/szkolenie']"
                    fragment="program"
                >
                    <span class="hero-nav-icon">📋</span>
                    <span class="hero-nav-label">Program</span>
                </a>
                <a
                    class="hero-nav-tile"
                    [routerLink]="['/szkolenie']"
                    fragment="logistics"
                >
                    <span class="hero-nav-icon">📍</span>
                    <span class="hero-nav-label">Informacje logistyczne</span>
                </a>
            </div>
        </div>
    </section>

    <section class="speakers" id="speakers">
        <div class="container">
            <h2>Wykładowcy</h2>
            <div class="speakers-grid">
                <div class="speaker-card">
                    <h3>Piotr Urbanowicz</h3>
                    <p class="role">Wiceprezes Krajowej Izby Kominiarzy</p>
                    <p class="topic">
                        Najczęstsze zaniedbania w instalacjach kominowych i
                        wentylacyjnych.
                    </p>
                </div>
                <div class="speaker-card">
                    <h3>iMieszkaniec.pl</h3>
                    <p class="role">Miron Bryła, Danuta Prot, Maciej Stępień</p>
                    <p class="topic">
                        Koniec z papierami: Jak cyfryzacja zmienia przeglądy w
                        spółdzielniach.
                    </p>
                </div>
                <div class="speaker-card">
                    <h3>Tomasz Saciłowski</h3>
                    <p class="role">Główny Urząd Nadzoru Budowlanego</p>
                    <p class="topic">
                        Narzędzia udostępnione przez GUNB dla Spółdzielni
                        Mieszkaniowych.
                    </p>
                </div>
                <div class="speaker-card">
                    <h3>Marta Muryn</h3>
                    <p class="role">
                        Ekspert ds. KOB i przeglądów, Szczecińskie TBS
                    </p>
                    <p class="topic">
                        Cyfrowa Książka Obiektu Budowlanego w praktyce.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="program" id="program">
        <div class="container">
            <h2>Program</h2>
            <div class="program-timeline">
                <div class="program-item">
                    <div class="time">09:30 - 10:00</div>
                    <div class="activity">Rejestracja</div>
                </div>
                <div class="program-item">
                    <div class="time">10:00 - 11:30</div>
                    <div class="activity">Pierwsza część wykładów</div>
                </div>
                <div class="program-item">
                    <div class="time">11:30 - 12:00</div>
                    <div class="activity">Przerwa kawowa</div>
                </div>
                <div class="program-item">
                    <div class="time">12:00 - 13:30</div>
                    <div class="activity">Druga część wykładów</div>
                </div>
                <div class="program-item">
                    <div class="time">13:30 - 14:30</div>
                    <div class="activity">Lunch</div>
                </div>
            </div>
        </div>
    </section>

    <section class="logistics" id="logistics">
        <div class="container">
            <h2>Informacje logistyczne</h2>

            <div class="logistics-items">
                <div class="logistics-item">
                    <h3>📅 Dane podstawowe</h3>
                    <ul>
                        <li>
                            <strong>Termin</strong> 26 lutego 2026 (czwartek)
                        </li>
                        <li>
                            <strong>Miejsce</strong> Atlas Tower, Al.
                            Jerozolimskie 123a (Plac Zawiszy)
                        </li>
                        <li><strong>Sala</strong> Piętro 6, Sala 4</li>
                        <li><strong>Godziny</strong> 10:00 - 14:00</li>
                    </ul>
                </div>
                <div class="logistics-item">
                    <h3>🚗 Dojazd autem</h3>
                    <p>
                        Parking naziemny dla uczestników znajduje się między
                        ulicami Grójecką i Al. Jerozolimskie tuż przy Pl.
                        Zawiszy. Przy wjeździe na parking, należy przekazać
                        informację, że kierują się Państwo na spotkanie do
                        Golden Floor. W Golden Floor należy pobrać bilecik na
                        podstawie którego zostaną Państwo rozliczeni i tym samym
                        okazanie go umożliwi z niego wyjazd.
                    </p>
                    <p class="parking-cost">
                        <strong>Koszt parkingu:</strong> 90
                        zł/brutto/dzień/samochód - rozliczenia są we własnym
                        zakresie w formie gotówki w recepcji Golden Floor.
                    </p>
                </div>

                <div class="logistics-item">
                    <h3>🏢 Wejście do centrum konferencyjnego</h3>
                    <p>
                        Wejście do budynku Atlas Tower możliwe jest od ul. Al.
                        Jerozolimskie 123A, po przejściu przez obrotowe drzwi
                        należy kierować się w stronę recepcji głównej budynku i
                        skręcić w lewo przed sklepem spożywczym BIEDRONKA.
                        Następnie przy użyciu kodu QR (dostępnego w recepcji
                        budynku), należy przejść przez bramki i udać się do holu
                        windowego, aby jedną z 8 wind dostać się na wskazane
                        piętro Golden Floor.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="cta">
        <div class="container">
            <div class="cta-box">
                <h2>Masz pytania? Skontaktuj się z nami!</h2>
                <div class="contact-info">
                    <p>W razie pytań prosimy o kontakt:</p>
                    <p class="contact-details">
                        <strong>Danuta Prot</strong> - Dyrektor Handlowy<br />
                        📧
                        <a href="mailto:danuta.prot@imieszkaniec.pl"
                            >danuta.prot@imieszkaniec.pl</a
                        ><br />
                        📞 <a href="tel:+48533495170">+48 533 495 170</a>
                    </p>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>
